function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import { consumeContext } from "../PlayerContext";
import "video-react/dist/video-react.css";
import { Player, ControlBar, BigPlayButton, LoadingSpinner } from "video-react";
import Measure from "./Measure";
import BusyScreen from "./BusyScreen";
import PosterContainer from "./PosterContainer";
import Poster from "../Poster";

var Video = function (_React$Component) {
  _inherits(Video, _React$Component);

  function Video(props) {
    _classCallCheck(this, Video);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {};

    _this.handleOverlayClick = function () {
      var player = _this.refs.player;

      if (player.getState().player.paused) {
        player.play();
      } else {
        player.pause();
      }
    };

    _this.handleResize = function (width, height) {
      _this.props.PlayerContext.setDimensions(width, height);
    };

    _this.pause = function () {
      _this.refs.player.pause();
    };

    props.playerRef(_this);
    return _this;
  }

  Video.prototype.isReady = function isReady() {
    var _props$PlayerContext$ = this.props.PlayerContext.state,
        videoState = _props$PlayerContext$.videoState,
        isOverlayLoaded = _props$PlayerContext$.isOverlayLoaded,
        overlay = _props$PlayerContext$.overlay;

    if (overlay && !isOverlayLoaded) {
      return false;
    }

    var _state = this.state,
        durationWorkaroundStarted = _state.durationWorkaroundStarted,
        durationWorkaroundDone = _state.durationWorkaroundDone;
    return !(!videoState || isNaN(videoState.duration) || durationWorkaroundStarted && !durationWorkaroundDone);
  };

  Video.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.refs.player.subscribeToStateChange(function (state) {
      _this2.props.PlayerContext.setVideoState(state);
    });
  };

  Video.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.startTime !== prevProps.startTime) {
      this.refs.player.seek(this.props.startTime);
    }
  };

  Video.prototype.renderControlBar = function renderControlBar() {
    var _props$PlayerContext$2 = this.props.PlayerContext.state,
        disableControlBarControls = _props$PlayerContext$2.disableControlBarControls,
        _props$PlayerContext$3 = _props$PlayerContext$2.autoHideControlBar,
        autoHideControlBar = _props$PlayerContext$3 === undefined ? true : _props$PlayerContext$3;
    return React.createElement(ControlBar, {
      autoHide: autoHideControlBar,
      className: disableControlBarControls ? "full-width-time-control" : null
    });
  };

  Video.prototype.render = function render() {
    var _props$PlayerContext$4 = this.props.PlayerContext.state,
        videoSrc = _props$PlayerContext$4.videoSrc,
        overlay = _props$PlayerContext$4.overlay,
        videoState = _props$PlayerContext$4.videoState,
        scale = _props$PlayerContext$4.scale;
    var _props = this.props,
        _props$startTime = _props.startTime,
        startTime = _props$startTime === undefined ? 0 : _props$startTime,
        autoPlay = _props.autoPlay,
        poster = _props.poster;
    return React.createElement(Player, {
      autoPlay: autoPlay,
      ref: "player",
      fluid: false,
      playsInline: true,
      width: "100%",
      height: "100%",
      startTime: startTime
    }, (Array.isArray(videoSrc) ? videoSrc : [videoSrc]).map(function (src) {
      return React.createElement("source", {
        key: "source-" + src,
        src: src
      });
    }), React.createElement(BigPlayButton, {
      position: "center"
    }), this.renderControlBar(), React.createElement(LoadingSpinner, null), React.createElement(BusyScreen, {
      isActive: !this.isReady()
    }), React.createElement(Measure, {
      onSizeChange: this.handleResize
    }), React.createElement(PosterContainer, {
      onClick: this.handleOverlayClick,
      videoState: videoState,
      scale: scale,
      frameSource: this.props.frameSource,
      poster: poster
    }, this.props.children, overlay && React.createElement(Poster, null)));
  };

  return Video;
}(React.Component);

Video.propTypes = process.env.NODE_ENV !== "production" ? {
  PlayerContext: PropTypes.object.isRequired,
  playerRef: PropTypes.func.isRequired,
  autoPlay: PropTypes.bool,
  startTime: PropTypes.number,
  frameSource: PropTypes.string,
  children: PropTypes.any,
  poster: PropTypes.string
} : {};
export default consumeContext(Video);